import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $HeaderModuleName } from "./header.types";

const getHeader = (state: IState) => getValueState(state, $HeaderModuleName);

const isFlyoutActive = (state: IState) => !!getHeader(state)?.flyoutActive;

const isSidebarActive = (state: IState) => !!getHeader(state)?.sidebarActive;

const isMobile = (state: IState) => !!getHeader(state)?.mobile;

export { isFlyoutActive, isMobile, isSidebarActive };
